import React from 'react'
import {Route, Switch} from 'react-router-dom'
import 'antd/dist/antd.css';
import 'styles/App.less'

import AppHeader from 'modules/AppHeader'
import CartDrawer from 'modules/AppHeader/CartDrawer'
import CookiesHandler from 'components/CookiesHandler'
import Routes from './Routes'
import Checkout from 'modules/Checkout'

const App = () => (
  <div className="App">
    <Switch>
      <Route path='/checkout'>
        <Checkout/>
      </Route>

      <Route>
        <header>
          <AppHeader/>
        </header>

        <section>
          <Routes/>
        </section>

        <CartDrawer/>
      </Route>
    </Switch>

    <CookiesHandler/>
  </div>
)

export default App
